/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_WorkInputs */

const en_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add work experience — this is the most heavily weighted ATS section`)
};

const de_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge Berufserfahrung hinzu — dies ist der am stärksten gewichtete ATS-Bereich`)
};

const fr_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez une expérience professionnelle — c'est la section la plus pondérée par l'ATS`)
};

const es_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade experiencia laboral — esta es la sección más valorada por el ATS`)
};

const it_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi esperienza lavorativa — questa è la sezione più pesata dall'ATS`)
};

const nl_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg werkervaring toe — dit is de zwaarst gewogen ATS-sectie`)
};

const pl_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj doświadczenie zawodowe — to najwyżej oceniana sekcja ATS`)
};

const fi_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää työkokemus — tämä on ATS:n eniten painottama osio`)
};

const da_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj erhvervserfaring — dette er den mest vægtede ATS-sektion`)
};

const sv_ats_tip_add_work = /** @type {(inputs: Ats_Tip_Add_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till arbetslivserfarenhet — detta är den mest viktade ATS-sektionen`)
};

/**
* | output |
* | --- |
* | "Add work experience — this is the most heavily weighted ATS section" |
*
* @param {Ats_Tip_Add_WorkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_work = /** @type {((inputs?: Ats_Tip_Add_WorkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_WorkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_work(inputs)
	if (locale === "fr") return fr_ats_tip_add_work(inputs)
	if (locale === "es") return es_ats_tip_add_work(inputs)
	if (locale === "it") return it_ats_tip_add_work(inputs)
	if (locale === "nl") return nl_ats_tip_add_work(inputs)
	if (locale === "pl") return pl_ats_tip_add_work(inputs)
	if (locale === "fi") return fi_ats_tip_add_work(inputs)
	if (locale === "da") return da_ats_tip_add_work(inputs)
	if (locale === "sv") return sv_ats_tip_add_work(inputs)
	return en_ats_tip_add_work(inputs)
});